import React from 'react';
import LoadingPlaceholder from '../../../muiComponents/LoadingPlaceholder';
import { Card } from '@mui/material';

const LoadingTab = () => {
    return (
        <div className='your-property__container'>
            <LoadingPlaceholder variant='text' height={24} width={'300px'} />
            <Card className='your-properties__form'>
                <LoadingPlaceholder variant='text' height={60} width={'100%'} />
                <LoadingPlaceholder variant='text' height={60} width={'100%'} />
                <LoadingPlaceholder variant='text' height={60} width={'100%'} />
                <LoadingPlaceholder variant='text' height={60} width={'100%'} />
            </Card>
        </div>
    );
};

export default LoadingTab;
